var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoFilled = function SvgInfoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.005 22a9.58 9.58 0 0 0 3.86-.787 10.248 10.248 0 0 0 5.353-5.353A9.621 9.621 0 0 0 22 11.995a9.579 9.579 0 0 0-.787-3.86 10.31 10.31 0 0 0-2.167-3.196 10.06 10.06 0 0 0-3.191-2.162A9.687 9.687 0 0 0 11.995 2a9.65 9.65 0 0 0-3.855.777A10.136 10.136 0 0 0 4.949 4.94a10.192 10.192 0 0 0-2.167 3.196A9.632 9.632 0 0 0 2 11.995c0 1.372.262 2.66.787 3.865a10.263 10.263 0 0 0 2.167 3.186c.92.92 1.982 1.642 3.186 2.167a9.568 9.568 0 0 0 3.865.787ZM12 6.5A1.25 1.25 0 1 0 12 9a1.25 1.25 0 0 0 0-2.5Zm0 3.5a1 1 0 0 0-1 1v5.5a1 1 0 1 0 2 0V11a1 1 0 0 0-1-1Z",
    fill: "#000"
  })));
};
export default SvgInfoFilled;